import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';

const AuthCallback: React.FC = () => {
  const { handleCallback, isLoading } = useAuth();
  const [hasProcessed, setHasProcessed] = useState(false);

  useEffect(() => {
    if (!hasProcessed) {
      setHasProcessed(true);
      handleCallback();
    }
  }, [hasProcessed, handleCallback, isLoading]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <span></span>
        </div>
        <p>Completing authentication...</p>
      </div>
    );
  }

  return (
    <div className="auth-callback">
      <p>Authentication completed. Redirecting...</p>
    </div>
  );
};

export default AuthCallback;